import { Logo } from "@/assets/logo";
import { toast } from "@/hooks/use-toast";
import axios from "axios";
import { useState } from "react";
import { useLocation } from "wouter";
import { useDispatch } from "react-redux";
import { setUser } from "@/store/slices/userSlice";
import BASE_URL from "@/constants";
axios.defaults.withCredentials = true


export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [, setLocation] = useLocation();
const dispatch = useDispatch();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);



// Inside your try block after API call:
try {
  const response = await axios.post(BASE_URL+"/users/login", {
    email,
    password,
  },);

  const { company_name, isManager, role, email: userEmail, name } = response.data;

  // Dispatch to Redux store
  dispatch(
    setUser({
      company_name,
      isManager,
      role,
      email: userEmail,
      name:name,
    })
  );

  toast({
    title: "Succesfully Logged in", 
  });
   setLocation("/dashboard");

  // Optional: navigate somewhere, or show success toast

} catch (error: any) {

  toast({
    title: "Error",
    description: `${error.response?.data?.message || "Login failed"}`,
    variant: "destructive",
  });
} finally {
  setLoading(false);
}

  };

  return (
    <div className="min-h-screen bg-purple-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-xl space-y-6">
        {/* Header with Logo and Title */}
        <div className="flex flex-col items-center space-y-2">
          <Logo className="" />
          <h1 className="text-xl font-bold text-purple-700">PO Management System</h1>
          <p className="text-sm text-gray-500">Login to continue</p>
        </div>

        {/* Error Message */}
        {error && <p className="text-red-600 text-sm text-center">{error}</p>}

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 rounded-lg transition"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {/* Optional footer/help */}
        <div className="text-center text-sm text-gray-500">
          Need access? Contact your admin.
        </div>
      </div>
    </div>
  );
}
